export const columns = [
  {
    Header: '#',
    accessor: 'id',
  },
  {
    Header: 'Name',
    accessor: 'name',
  },
  {
    Header: 'Domain',
    accessor: 'domain',
  },
  {
    Header: 'Status',
    accessor: 'status',
    disableGlobalFilter: true,
  },
  {
    Header: 'Requests',
    accessor: 'request_count',
    disableGlobalFilter: true,
  },
  {
    Header: 'Created By',
    accessor: 'created_by',
    disableGlobalFilter: true,
  },
  {
    Header: 'Last Used',
    accessor: 'last_used_at',
    disableGlobalFilter: true,
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    disableSortBy: true,
    disableGlobalFilter: true,
  },
];
